import { render, staticRenderFns } from "./DepartmentJixiaoReport.vue?vue&type=template&id=60acc39a&scoped=true"
import script from "./DepartmentJixiaoReport.vue?vue&type=script&lang=js"
export * from "./DepartmentJixiaoReport.vue?vue&type=script&lang=js"
import style0 from "./DepartmentJixiaoReport.vue?vue&type=style&index=0&id=60acc39a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60acc39a",
  null
  
)

export default component.exports